
import VueScrollTo from 'vue-scrollto';
import { Component, Vue } from 'vue-property-decorator';
import {
  IconButton,
  Heading,
  NavBar,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: { Heading, NavBar, IconButton, BaseText }
})
export default class PensionSectionHero extends Vue {
  readonly NebraskaColors = NebraskaColors;

  scroll(targetId: string) {
    VueScrollTo.scrollTo(targetId, 1000);
  }
}
